import React from "react";
import ProductList from "./ProductList";

function Home(props) {
  return (
    <>
      <ProductList />
    </>
  );
}

export default Home;
